import { cloneDeep } from "lodash";
import { OrderType } from "../../search/utils/constants";

export const TemplateType = {
  TEXT: "text",
  SET: "set",
};

export const getDefaultValues = (defaultContent) =>
  cloneDeep({
    name: "",
    content: defaultContent,
    inputMethod: TemplateType.TEXT,
  });

export const templateTypes = [
  { label: "Texto", value: TemplateType.TEXT },
  { label: "Casillas de verificación", value: TemplateType.SET },
];

/**
 * For creation / updating, the max items is the max items per template.
 */
export const templateMaxItems = {
  [TemplateType.TEXT]: {
    [OrderType.IMAGING]: 10,
    [OrderType.LABORATORY]: null,
    [OrderType.MANUAL]: null,
  },
  [TemplateType.SET]: {
    [OrderType.IMAGING]: null,
    [OrderType.LABORATORY]: null,
    [OrderType.MANUAL]: null,
  },
};

/**
 * When selecting a template, the max items you can select in a SET type template.
 *
 * PRACTICES: con el tipo de plantilla unificado (order-homologar, Story 8) no
 * se puede saber con certeza si el contenido es imaging o laboratory, así que
 * se aplica el límite restrictivo de imaging por default (mismo criterio que
 * templateMaxItems más abajo) en vez de dejarlo sin límite por accidente.
 */
export const templateMaxSelectedSetItems = {
  [OrderType.IMAGING]: 10,
  [OrderType.LABORATORY]: null,
  [OrderType.MANUAL]: null,
  [OrderType.PRACTICES]: 10,
};
